/** Strings of the `/agents` pages (list, detail shell, overview, activity, changes, verifications, manual): `agentsEn` is the source, `agentsCs` must have the same keys. */
export const agentsEn = {
  agents: {
    title: "Agents",
    subtitle:
      "The AI workforce: what each agent is doing, what it burns, and the switch to pause it.",
    loadFailed: "Couldn't load the agents.",
    none: "No agents registered.",
    agent: "Agent",
    active: "Active",
    paused: "Paused",
    pause: "Pause",
    resume: "Resume",
    back: "Back",
    save: "Save",
    saving: "Saving…",
    remove: "Remove",
    never: "never",
    tickets_one: "{{count}} ticket",
    tickets_few: "{{count}} tickets",
    tickets_other: "{{count}} tickets",
    sources: {
      email: "Email",
      whatsapp: "WhatsApp",
      discord: "Discord",
      meeting: "Meeting",
      duplicate_scan: "Duplicate scan",
      idle_proposal: "Proposal while idle",
      verification: "Verification",
      review: "Review",
      log_triage: "Log triage",
      analyst_learning: "Learning",
      metodej_wi: "Work item",
      document: "Document",
    },
    lair: {
      title: "In lair",
      subtitle:
        "Agents each person runs on their own machine and Claude subscription. They have no queue or spend here; what they get from Hub is set here for the whole team.",
      claims:
        "Every lair session holds a claim in Hub on the task it works on: a ticket, or a short description with the repo and paths it changes. A heartbeat keeps the claim alive, it lapses after 3 minutes without one and is released when the task or the session ends. Before its first write (a file edit, git push, a write to Hub) the session compares its task with the live claims of the whole team, Metoděj included. On the same ticket or overlapping paths in the same repo it stops and asks you: hand the work to the holder, who gets a message with what it meant to do, or take the claim over, and the holder is told and stops (from Metoděj at work the work can only be handed over). When Hub does not answer, nothing is written. lair's Who does what panel lists every live claim, and a ticket's detail shows the lair session working on it.",
      kicker: "Agent in lair",
      back: "← Agents",
      skillCount: "Skills: {{on}} of {{total}}",
      runners: {
        title: "CI runners in lair",
        subtitle:
          "Machines whose lair runs Hub's lair-local CI jobs (lint, tests) when the machine is free. Each person switches theirs on or off in lair; offboarding removes them.",
        person: "Person",
        machine: "Machine",
        created: "Created",
        contacted: "Last contact",
        never: "never",
      },
      skillsIntro:
        "Company skills from the netlion.cz/claude-skills marketplace this agent gets in everyone's lair, read at each start. A new skill starts off. Without Hub, lair uses the list it shipped with.",
      personas: {
        planner: {
          name: "Planner",
          description:
            "Talks a request through with you, turns it into tickets with a plan and criteria, and hands them to the developer or to Metoděj.",
        },
        developer: {
          name: "Developer",
          description:
            "Builds a ticket with you in your checkout: runs the project, writes the change, passes the checks. Commits under your name.",
        },
        creator: {
          name: "Creator",
          description:
            "Starts a new project from scratch: questions up front, the spec, the wiki and the first tickets.",
        },
        tester: {
          name: "Tester",
          description:
            "Guides you through a manual test of a ticket; you click, it notes the result.",
        },
      },
    },
    tabs: {
      overview: "Overview",
      activity: "Activity",
      verifications: "Verifications",
      changes: "Undoable changes",
      manual: "Manual",
      email: "Email",
      whatsapp: "WhatsApp",
      discord: "Discord",
      meetings: "Meetings",
      learnings: "Learnings",
      sources: "Sources",
      passes: "Passes",
      skills: "Skills",
    },
    blockers: {
      title: "Blocked by people",
      intro:
        "Tickets lying with a person that other tickets wait on. Until they move, the agents can't start what waits behind them.",
      blocks: "Blocks {{count}}",
      with: "with {{name}}",
      nobody: "nobody assigned",
      since: "since",
    },
    idle: {
      title: "Idle because",
      paused: "Paused.",
      draining: "A deploy is draining the agents, nothing new starts until it ends.",
      limited: "Subscription limit reached, waits until",
      accessError: "Token refused: {{error}}",
      ready: "{{tickets}} in progress, one is taken on the next pass.",
      criteria:
        "{{tickets}} in progress, waiting for Prokop and Vratislav to agree the acceptance criteria.",
      notStarted: "{{tickets}} assigned but still in new; only tickets in progress are taken.",
      waiting: "{{tickets}} waiting on another ticket",
      holds: "holds {{count}}",
      unblocked: "{{tickets}} with no open blocker left: Start anyway on the ticket.",
      empty: "Nothing assigned.",
    },
    tile: {
      waitingForLimit: "Waiting for limit",
      onFallback: "On fallback subscription",
      tokenRefused: "Token refused",
      mailPending:
        "The email about the held access did not go out; Hub keeps trying to send it again.",
      pending: "{{count}} pending",
      tok: "tok",
      today: "today",
      thisMonth: "this month",
      estimateSubscription: "estimate, subscription",
      lastActivity: "Last activity:",
      workingOn: "Working on now",
      withUser: "with {{name}}",
    },
    figures: {
      today: "Today",
      last30: "Last 30 days",
      runsOn: "Runs on",
      model: "Model",
      subscription: "Subscription",
      gatewayKey: "Gateway key",
      engine: "engine: {{engine}}",
      noAccess: "no model access of its own",
      estimateNotBill: "{{cost}} — estimate at list price, not a bill",
    },
    run: {
      started: "{{source}} pass started.",
      failed: "Couldn't start the run.",
      starting: "Starting…",
      runSource: "Run {{source}}",
    },
    overview: {
      tokensPerDay: "Tokens per day (30 days)",
      costPerDay: "Estimated cost per day (USD)",
    },
    activity: {
      empty: "No runs yet — the agent hasn't done anything.",
      started: "Started",
      source: "Source",
      trigger: "Trigger",
      status: "Status",
      tokens: "Tokens in/out",
      cost: "Cost",
      outcome: "Outcome",
      nothingNew: "nothing new",
      analysis: "analysis",
      mr: "MR",
    },
    runStatus: {
      running: "running",
      completed: "completed",
      failed: "failed",
      interrupted: "interrupted",
    },
    changes: {
      title: "What it changed",
      when: "When",
      project: "Project",
      what: "What",
      reverted: "reverted",
      revert: "Revert",
      reverting: "Reverting…",
      revertedToast: "Change reverted.",
      revertFailed: "Couldn't revert the change.",
      empty: "Nothing changed by this agent yet.",
    },
    verifications: {
      empty: "No verifications yet — hand Prokop a work item in an internal-testing state.",
      when: "When",
      workItem: "Work item",
      env: "Env",
      mode: "Mode",
      verdict: "Verdict",
      summary: "Summary",
      tokens: "Tokens in/out",
      cost: "Cost",
      evidence: "Evidence",
      screenshot: "screenshot",
      verdicts: {
        passed: "passed",
        failed: "failed",
        not_testable: "not testable",
        unclear: "unclear",
      },
      stallsTitle: "Why runs ended without a verdict (30 days) — {{stalled}} of {{total}}",
      stallsEmpty: "Every run in the last 30 days ended with a verdict.",
      latest: "latest:",
      causes: {
        no_access: {
          label: "Needed an account it didn't have",
          fix: "Share the role's account in the project's vault collection.",
        },
        model_error: {
          label: "The model failed, not the app",
          fix: "Check the agent's model access on AI Spend; Prokop retries by himself and tells the admins after a day.",
        },
        gate_locked: {
          label: "Behind the SSO gate",
          fix: "Set Prokop's gate login below, and give that account access to the app in Authentik.",
        },
        locked_out: {
          label: "Login wall, no account",
          fix: "Share a test account in the project's vault collection.",
        },
        missing_data: {
          label: "No data to test on",
          fix: "Seed the environment, or say in the ticket how to get the data.",
        },
        environment_broken: {
          label: "Environment broken or change not deployed",
          fix: "Check the environment's deploy.",
        },
        page_unreachable: { label: "Site didn't load", fix: "Check the environment is up." },
        cannot_observe: {
          label: "Effect can't be seen from a browser or the test inbox",
          fix: "Test by hand, or make the effect visible.",
        },
        ticket_ambiguous: {
          label: "Ticket doesn't say what should be true",
          fix: "Sharpen the description or add acceptance criteria.",
        },
        out_of_budget: {
          label: "Ran out of budget",
          fix: "Narrow the ticket, or raise TESTER_MAX_COST_USD_PER_WI.",
        },
        out_of_steps: {
          label: "Ran out of steps",
          fix: "Narrow the ticket, or raise TESTER_MAX_TURNS.",
        },
        inferred_only: {
          label: "Some criteria only checkable from the code",
          fix: "Verify the listed criteria by hand; the run could not see them in the application.",
        },
        unobserved: {
          label: "Pass not backed by anything seen",
          fix: "Read the run — it concluded from the code or a step that failed.",
        },
        unfounded: {
          label: "A tick not backed by what he saw",
          fix: "Read the run: a criterion was ticked from the code or after a step that failed.",
        },
        smoke_unclear: { label: "Screenshot check undecided", fix: "Usually a one-off; rerun it." },
        not_in_browser: {
          label: "Out of his reach",
          fix: "Check it by hand: server logs, monitoring, configuration or production.",
        },
        wrong_state: {
          label: "Ticket not in internal testing",
          fix: "Hand it over from the right state.",
        },
        no_environment: {
          label: "Environment has no URL",
          fix: "Set it in the project's settings.",
        },
        no_browser: { label: "Browser sidecar missing", fix: "Check BROWSER_WS_URL." },
        advance_blocked: {
          label: "Passed, but the workflow refused to move it",
          fix: "Check the ticket's transition gate (e.g. no manager).",
        },
        production: {
          label: "Production — never tested",
          fix: "Check it by hand, or hand the ticket over on dev or test.",
        },
        production_tester: {
          label: "A person tests before production",
          fix: "The project's Production tester tests it; nothing for Prokop.",
        },
        other: { label: "Other", fix: "Read the run's summary." },
        unknown: { label: "Not recorded (older runs)", fix: "Read the run's summary." },
      },
    },
    access: {
      title: "Model access",
      onFallback: "{{own}} reached its limit, so it runs on {{fallback}} until",
      itResets: "it resets",
      limited: "Subscription limit reached — waiting until",
      gatewayKey: "Gateway key",
      fromEnv: "— from the deploy env —",
      none: "— none —",
      gatewayKeyHelp:
        "Pays for what runs on the gateway, also next to a subscription (embeddings, models the subscription can't run).",
      subscription: "Subscription",
      noneGateway: "— none, runs on the gateway key —",
      runsOnNow: "Runs on it now: {{engine}}.",
      fallbackSubscription: "Fallback subscription",
      fallbackNone: "none, waits for the limit to reset",
      fallbackHelp:
        "When the subscription uses up its 5-hour or weekly limit, the agent runs on this one and goes back once the limit resets.",
      model: "Model",
      modelDefault: "default: {{model}}",
      modelHelp:
        "A gateway model on the API (e.g. gpt-5.5), a GPT model on Codex (empty = the account's default). The Claude subscription runs Claude models only.",
      engine: {
        api: "API (gateway key)",
        subscription: "Claude subscription",
        codex: "ChatGPT subscription (Codex)",
      },
      kind: { gateway_key: "key", claude_token: "Claude", codex_login: "ChatGPT" },
      saved: "Model access saved.",
      saveFailed: "Couldn't save the model access.",
      testFailed: "Couldn't run the test.",
      works: "Works",
      failed: "Failed",
      testResult: "{{result}} on {{engine}}{{model}} in {{seconds}} s: {{detail}}",
      test: "Test",
      testing: "Testing…",
      saveFirst: "Save first",
      testHint: "One tiny real call on the saved engine",
      manage: "Manage keys and subscriptions",
      changed: "Changed",
      by: "by {{name}}",
      limitsOwn: "Subscription",
      limitsFallback: "Fallback",
      runsOnItNow: "(runs on it now)",
      noLimits: "No limits read yet.",
      sharedRead: "Shared by every agent on {{name}}, read",
      testReadsIt: "; Test reads it now.",
    },
    coder: {
      title: "Settings",
      rounds: "Fix attempts when checks fail",
      help: "A ticket is done only when the project's pipeline passes, lint and other checks allowed to fail included. After this many red pipelines in a row the ticket goes to a person.",
      saved: "Settings saved.",
      saveFailed: "Couldn't save the settings.",
    },
    gate: {
      title: "SSO gate",
      description:
        "Sites behind {{hosts}} are opened with this service account (Authentik app password, sent only to gated sites). One login covers every project behind the gate. Whether it gets in is shown per environment under the project's Tester access check.",
      usernameSet: "Username (set)",
      usernameNotSet: "Username (not set)",
      password: "App password",
      passwordStored: "stored, type to replace",
      passwordNew: "stored encrypted",
      saved: "Gate login saved.",
      saveFailed: "Couldn't save the gate login.",
    },
    voice: {
      title: "Voice spend",
      description:
        "Calls go to the main ElevenLabs workspace while it has credits and to the backup once it runs out; they come back by themselves when the credits renew.",
      loadFailed: "Couldn't load the voice spend.",
      primary: "Main workspace",
      backup: "Backup workspace",
      notSetUp: "{{workspace}}: not set up ({{key}}).",
      callsHere: " · calls go here now",
      noAgent: " · no agent yet (run provision:radim-elevenlabs)",
      plan: "plan",
      credits: "{{tier}}: {{used}} of {{limit}} credits used, {{left}} left{{renews}}.",
      renews: ", renews {{date}}",
      creditsUnknown:
        "Credits unknown: the key can't read the plan (needs the User read permission).",
      exhausted: "Out of credits, skipped until {{date}}.",
      calls:
        "Last {{days}} days: {{count}} call(s), {{minutes}} min, {{credits}} credits{{perMin}}{{cost}}.",
      perMin: " ({{n}} per min)",
      twilioError: "Twilio: {{error}}",
      twilioBalance: "Twilio: balance {{balance}} {{currency}}{{month}}{{calls}}.",
      twilioMonth: ", this month ${{usd}}",
      twilioCalls: " (calls: {{count}}, {{minutes}} min, ${{usd}})",
      twilioNotSetUp: "Twilio: not set up (TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN).",
    },
    whatsapp: {
      title: "WhatsApp",
      description:
        "People link their WhatsApp on their Profile and then plan their projects with Radim in the chat, typed, as voice notes or on a call (his ElevenLabs agent takes calls).",
      loadFailed: "Couldn't load Radim's WhatsApp.",
      number: "Number",
      noNumber: "Meta didn't return the number: check WHATSAPP_PHONE_NUMBER_ID and the token.",
      notSetUp: "Not set up. Needs WHATSAPP_CLOUD_TOKEN and WHATSAPP_PHONE_NUMBER_ID from Meta.",
      webhook:
        "Incoming messages need WHATSAPP_APP_SECRET and WHATSAPP_VERIFY_TOKEN, and the webhook /api/webhooks/whatsapp set in Meta.",
    },
    queue: {
      title: "Queue",
      loading: "Loading…",
      empty: "Nothing waiting — hand Prokop a work item in an internal-testing state.",
      held: "{{tickets}} held across {{projects}}.",
      projects_one: "{{count}} project",
      projects_few: "{{count}} projects",
      projects_other: "{{count}} projects",
      cost: "Testing them now costs at most {{cost}} — that's the per-ticket caps added up, and most tickets come in well under.",
      pass: {
        nightly: "A pass over handed tickets",
        asap: "An asap request",
        manual: "A manual pass",
      },
      running: "{{pass}} is running — one pass at a time.",
      noBrowser: "No testing browser is configured on the server, so nothing can run.",
      prokopPaused: "Prokop is paused.",
      start: "Test the whole queue now",
      started_one: "Testing {{count}} ticket now.",
      started_few: "Testing {{count}} tickets now.",
      started_other: "Testing {{count}} tickets now.",
      startedDesc: "They finish one at a time — each reports on its own ticket.",
      startFailed: "Couldn't start the pass.",
    },
    guide: {
      heading: "What this agent can do",
      configure: "Configure",
      useIt: "Use it",
      suggestions: "Suggestions",
      fullManual: "Full manual:",
      inWiki: "in the wiki.",
      analyst: {
        intro:
          "Feed it a channel, it proposes actions — {{proposes}}. It never applies anything itself: every proposal waits in",
        intro2:
          "for your approve/reject, and each one shows its reasoning, a quote from the source, and a link back to it.",
        proposes:
          "new work items / tasks / bugs / ideas, comments on existing items, priority changes, spec additions, fixed prices, estimates, and duplicate merges",
        footer:
          "Activity below shows every run with its real token burn and estimated cost; Pause stops all of it instantly.",
        wikiAnalysis: "AI Analýza",
        wikiAgents: "Agenti",
        email: {
          title: "Forwarded email",
          what: "Reads client emails forwarded to the watched mailbox (every ~15 min) and proposes follow-up actions with the sender's project as context.",
          how1: "Forward (or have the client write to) the watched mailbox — see the Email page for the address.",
          how2: "Map the sender's address or domain to a project under Email → Routing.",
          how3: "Proposals appear in Suggestions; attachments (images, PDFs) are read too.",
          link: "Email sources",
        },
        whatsapp: {
          title: "WhatsApp chats",
          what: "Continuously reads the group chats you pair and turns new messages into proposals.",
          how1: "Link a WhatsApp account once (Account → QR code).",
          how2: "Pair a group with “Pair new chat” and map it to a project.",
          how3: "Open a paired chat anytime to see its transcript and what each message led to.",
          link: "WhatsApp sources",
        },
        discord: {
          title: "Discord text channels",
          what: "The bot passively reads the text channels you put on its watchlist — the team's working discussion becomes proposals.",
          how1: "Invite the bot to the server (see the Bot modal for setup) and “Watch” a channel.",
          how2: "Map the channel to a project for sharper, item-aware proposals.",
          link: "Discord sources",
        },
        meetings: {
          title: "Voice meetings",
          what: "Invite the agent into a Discord voice channel — it records who said what (per-speaker audio), transcribes the meeting, and proposes follow-ups.",
          how1: "On Meetings, click “Record meeting”, pick the voice channel and a project, then “Join & record”.",
          how2: "After the meeting, “Stop & analyse” — the transcript and proposals arrive within minutes.",
          how3: "Audio is deleted after a successful analysis; only the transcript is kept.",
          link: "Meetings",
        },
        transcripts: {
          title: "Meeting transcripts",
          what: "Paste any transcript (a call, an offline meeting's notes) and get the same analysis by hand.",
          how1: "On Meetings, “Add meeting” → pick projects → paste the text → “Analyse transcript”.",
          link: "Meetings",
        },
        duplicates: {
          title: "Duplicate scan",
          what: "Sweeps open work items for tickets that track the same work (text + meaning) and proposes merges.",
          how1: "On Suggestions, click “Scan for duplicates”; review each proposed group and Merge or Reject.",
        },
      },
      tester: {
        intro:
          "Prokop is the team's tester: hand him a ticket that's ready for internal testing and he verifies the feature in a real browser — reading the project's wiki first for context — then comments the result and moves the ticket along, advancing it on a pass, returning it to the developer on a failure, or handing it back when he can't test. He works nights; say “asap” in a comment when it can't wait.",
        footer:
          "Activity below shows every run with its real token burn and estimated cost; Pause stops all of it instantly.",
        wikiName: "Agent Tester",
        hand: {
          title: "Hand him a ticket",
          what: "Assign a work item that is in an internal-testing state on dev or test to Prokop. He picks it up within a minute, the way Metoděj and Vratislav pick up theirs. Production he never tests: he verifies by using the application, and on main that would mean real orders and real data.",
          how1: "He's a member of every project — nothing to set up before handing him a ticket.",
          how2: "On a work item in internal testing, use “Hand to Prokop” (or set the assignee to Prokop). Where the project wants a person to test before production, the button is missing and Hub refuses Prokop as assignee: the Production tester does that test.",
          how3: "He opens the project's deployed site for that environment in a real browser.",
          how4: "He verifies only what the ticket describes.",
          how5: "A ticket in internal testing on main comes straight back — check that one by hand.",
        },
        asap: {
          title: "As soon as it's his",
          what: "Every minute he tests what he holds and hasn't tried since it was handed to him, moved or commented on. A ticket he kept without a verdict is retried a day later, not every minute.",
          how1: "Want him to look at something specific? Comment “@Prokop … asap” on the ticket and say what.",
          how2: "The comment doubles as his brief: say what to look at and he focuses there.",
          how3: "“Test the whole queue now” on this page retests everything he holds, tried or not.",
          how4: "One pass at a time: while a batch runs, the button says so instead of starting a second.",
          how5: "He only takes tickets he's holding; ask him on someone else's and he'll say so.",
        },
        result: {
          title: "What it does with the result",
          what: "It comments the outcome on the ticket and takes the matching workflow action, so the ball moves on its own.",
          how1: "Passed → comments ✅ and advances the ticket to the next step (the ball goes to the next owner).",
          how2: "Failed → comments ❌ with repro details + a screenshot and returns it to the developer.",
          how3: "Can't test / unclear → comments why and hands the ticket back to whoever gave it.",
        },
        login: {
          title: "Pages behind a login",
          what: "He looks the site's account up in Vault by its URL and signs in himself — nothing to configure. Admin screens stop coming back as “not testable”.",
          how1: "Keep test accounts in the project's Vault collection; name the testing one “test…”.",
          how2: "Several matching accounts and none marked as a test one → he signs in with none and says so.",
          how3: "Never on production: on main he always tests signed out.",
          how4: "He signs in once per site and reuses that session for the whole batch.",
        },
        external: {
          title: "Checking other systems",
          what: "When a ticket's effect lands outside the tested site — an order in the customer's ERP, an issued invoice — he opens that system in the browser and looks. Many of them have no usable API; this is how a human would check too.",
          how1: "Project settings → “External services (Prokop)”: name, URL, what it's for.",
          how2: "Anything not listed there is unreachable for him, links on the page included.",
          how3: "He signs in with whatever Vault holds for that URL — so keep only test accounts there.",
        },
        smoke: {
          title: "Smoke vs. agentic — and cost",
          what: "It starts with a cheap smoke check (one screenshot + load signals). Only if that can't judge the ticket does it escalate to full agentic browsing (clicking, typing).",
          how1: "Most tickets settle on the smoke check for a fraction of a cent.",
          how2: "Agentic runs are bounded by a per-ticket cost cap and a step limit.",
          how3: "Every run's real token burn and cost show in Activity below; Pause stops it all.",
        },
      },
      maintainer: {
        intro:
          "Vratislav is the team's maintainer: he reviews the merge request of every ticket parked at the dev merge gate he holds — against the ticket, and against the code around it — then merges it or sends it back to the developer with findings. He merges into dev and nowhere else; test and production stay a person's call.",
        footer: "Activity below shows every run; Pause stops all of it instantly.",
        wikiName: "Agent Vratislav",
        project: {
          title: "Give him a project",
          what: "He merges nothing on a project he isn't a member of. Adding him as a Maintainer in GitLab is the whole opt-in — the member sync mirrors it into Hub within minutes.",
          how1: "Add “Vratislav Síťolev” to the GitLab project with the Maintainer role.",
          how2: "From then on he takes the ticket's empty Maintainer slot himself — a human already in the slot is never displaced.",
          how3: "Leave him out and every merge gate stays exactly as manual as it was.",
        },
        gate: {
          title: "The dev merge gate",
          what: "Every few minutes he looks at the tickets parked at “merge into dev” that he holds, and takes the ones whose merge request is ready to be read.",
          how1: "He merges only into dev: an MR aimed at main or test he leaves alone and says so.",
          how2: "Ready means not a draft, no conflicts, green pipeline, approvals given, discussions resolved.",
          how3: "Anything else stops him before the review: he comments why once, and stays quiet until it changes.",
          how4: "After a merge he moves the ticket on to internal testing, where Prokop picks it up.",
        },
        review: {
          title: "He reads the code first",
          what: "Before merging he reviews the merge request the way a senior maintainer would: does it do what the ticket asked, does it break anything else, is it correct, is it written the way this repository writes code. He reads the diff and then opens the files around it — callers, tests, a neighbouring file for the conventions.",
          how1: "Approves → merges, and the review (with any minor notes) lands on the MR and the ticket.",
          how2: "Requests changes → does not merge: findings go on both, and the ticket goes back to the developer — where that's Metoděj, he fixes them and it comes round again.",
          how3: "Same commit back with nothing changed → he says so instead of paying for the same review twice.",
          how4: "After 3 rounds he stops bouncing it and asks a person to look.",
          how5: "A diff too big to read honestly, or no AI gateway configured, means no merge — never a merge without a review.",
        },
        never: {
          title: "What he never does",
          what: "Production is yours. He never merges into main, never promotes dev→test, never merges code he hasn't read, and never resolves a conflict or approves anything on anyone's behalf.",
          how1: "test and main gates stay manual — the “Merged into …” button, same as before.",
          how2: "He can't run anything — no tests, no build, no browser; that's Prokop's half.",
          how3: "Pause on this page stops him instantly; every merge he made is a normal GitLab merge you can revert.",
        },
      },
    },
  },
};

export const agentsCs: typeof agentsEn = {
  agents: {
    title: "Agenti",
    subtitle:
      "AI pracovní síla: co který agent právě dělá, kolik spotřebovává a vypínač pro jeho pozastavení.",
    loadFailed: "Agenty se nepodařilo načíst.",
    none: "Žádní registrovaní agenti.",
    agent: "Agent",
    active: "Aktivní",
    paused: "Pozastavený",
    pause: "Pozastavit",
    resume: "Obnovit",
    back: "Zpět",
    save: "Uložit",
    saving: "Ukládání…",
    remove: "Odebrat",
    never: "nikdy",
    tickets_one: "{{count}} tiket",
    tickets_few: "{{count}} tikety",
    tickets_other: "{{count}} tiketů",
    sources: {
      email: "E-mail",
      whatsapp: "WhatsApp",
      discord: "Discord",
      meeting: "Schůzka",
      duplicate_scan: "Hledání duplicit",
      idle_proposal: "Návrh z volné chvíle",
      verification: "Ověření",
      review: "Review",
      log_triage: "Třídění logů",
      analyst_learning: "Poučení",
      metodej_wi: "Pracovní položka",
      document: "Dokument",
    },
    lair: {
      title: "V lairu",
      subtitle:
        "Agenti, které si každý pouští u sebe na svém předplatném Claude. Frontu ani spotřebu tady nemají, co jim Hub dává, se nastavuje tady pro celý tým.",
      claims:
        "Každá session lairu si v Hubu drží nárok na úkon, na kterém pracuje: tiket, nebo krátký popis s repem a cestami, které mění. Nárok drží heartbeat, po 3 minutách bez něj propadne a uvolní se, když úkon nebo session skončí. Před prvním zápisem (úprava souboru, git push, zápis do Hubu) session porovná svůj úkon s živými nároky celého týmu včetně Metoděje. Při stejném tiketu nebo překryvu cest ve stejném repu se zastaví a zeptá se tě: předat práci držiteli, kterému přijde zpráva s tím, co chtěla udělat, nebo nárok převzít, držitel dostane oznámení a přestane (Metodějovi při práci jde práce jen předat). Když Hub neodpovídá, nic se nezapíše. Panel Kdo co dělá v lairu ukazuje všechny živé nároky a na detailu tiketu je vidět session lairu, která na něm pracuje.",
      kicker: "Agent v lairu",
      back: "← Agenti",
      skillCount: "Skilly: {{on}} z {{total}}",
      runners: {
        title: "CI runnery v lairu",
        subtitle:
          "Počítače, na kterých lair pouští CI joby Hubu s tagem lair-local (lint, testy), když je počítač volný. Každý si ho zapíná a vypíná v lairu sám, odchod z firmy je smaže.",
        person: "Kdo",
        machine: "Počítač",
        created: "Založen",
        contacted: "Poslední kontakt",
        never: "nikdy",
      },
      skillsIntro:
        "Firemní skilly z marketplace netlion.cz/claude-skills, které tenhle agent dostane v lairu u každého, načtou se při každém startu. Nový skill začíná vypnutý. Bez Hubu použije lair seznam, se kterým přišel.",
      personas: {
        planner: {
          name: "Planner",
          description:
            "Probere s tebou požadavek, udělá z něj tikety s plánem a kritérii a předá je developerovi nebo Metodějovi.",
        },
        developer: {
          name: "Developer",
          description:
            "Staví s tebou tiket ve tvém checkoutu: rozjede projekt, napíše změnu, projde kontroly. Commituje pod tvým jménem.",
        },
        creator: {
          name: "Creator",
          description: "Založí nový projekt od nuly: otázky předem, zadání, wiki a první tikety.",
        },
        tester: {
          name: "Tester",
          description: "Provede tě ručním testem tiketu, ty klikáš a on zapisuje výsledek.",
        },
      },
    },
    tabs: {
      overview: "Přehled",
      activity: "Aktivita",
      verifications: "Ověření",
      changes: "Vratné změny",
      manual: "Příručka",
      email: "E-mail",
      whatsapp: "WhatsApp",
      discord: "Discord",
      meetings: "Schůzky",
      learnings: "Poučení",
      sources: "Zdroje",
      passes: "Průchody",
      skills: "Skilly",
    },
    blockers: {
      title: "Blokováno lidmi",
      intro:
        "Tikety, které leží u člověka a čekají na ně další tikety. Dokud se nepohnou, agenti nemohou začít to, co za nimi čeká.",
      blocks: "Blokuje {{count}}",
      with: "u {{name}}",
      nobody: "nikdo nepřiřazen",
      since: "od",
    },
    idle: {
      title: "Nic nedělá, protože",
      paused: "Pozastaveno.",
      draining: "Nasazení vyprazdňuje agenty, nic nového nezačne, dokud neskončí.",
      limited: "Dosažen limit předplatného, čeká do",
      accessError: "Token odmítnut: {{error}}",
      ready: "{{tickets}} rozpracováno, jeden se vezme při dalším průchodu.",
      criteria:
        "{{tickets}} rozpracováno, čeká na shodu Prokopa a Vratislava na akceptačních kritériích.",
      notStarted: "{{tickets}} přiřazeno, ale stále v Nové; berou se jen rozpracované tikety.",
      waiting: "{{tickets}} čeká na jiný tiket",
      holds: "drží {{count}}",
      unblocked:
        "{{tickets}} bez otevřeného blokujícího tiketu: na tiketu použijte Přesto spustit.",
      empty: "Nic nepřiřazeno.",
    },
    tile: {
      waitingForLimit: "Čeká na limit",
      onFallback: "Na záložním předplatném",
      tokenRefused: "Token odmítnut",
      mailPending: "E-mail o zadrženém přístupu neodešel, Hub ho zkouší poslat znovu.",
      pending: "{{count}} čeká",
      tok: "tok.",
      today: "dnes",
      thisMonth: "tento měsíc",
      estimateSubscription: "odhad, předplatné",
      lastActivity: "Poslední aktivita:",
      workingOn: "Právě pracuje na",
      withUser: "u {{name}}",
    },
    figures: {
      today: "Dnes",
      last30: "Posledních 30 dní",
      runsOn: "Běží na",
      model: "Model",
      subscription: "Předplatné",
      gatewayKey: "Klíč brány",
      engine: "engine: {{engine}}",
      noAccess: "nemá vlastní přístup k modelu",
      estimateNotBill: "{{cost}} — odhad podle ceníku, ne faktura",
    },
    run: {
      started: "Průchod {{source}} spuštěn.",
      failed: "Spuštění se nepodařilo.",
      starting: "Spouštění…",
      runSource: "Spustit {{source}}",
    },
    overview: {
      tokensPerDay: "Tokeny za den (30 dní)",
      costPerDay: "Odhadované náklady za den (USD)",
    },
    activity: {
      empty: "Zatím žádné běhy — agent ještě nic neudělal.",
      started: "Spuštěno",
      source: "Zdroj",
      trigger: "Spouštěč",
      status: "Stav",
      tokens: "Tokeny vstup/výstup",
      cost: "Náklady",
      outcome: "Výsledek",
      nothingNew: "nic nového",
      analysis: "analýza",
      mr: "MR",
    },
    runStatus: {
      running: "běží",
      completed: "dokončeno",
      failed: "selhalo",
      interrupted: "přerušeno",
    },
    changes: {
      title: "Co změnil",
      when: "Kdy",
      project: "Projekt",
      what: "Co",
      reverted: "vráceno",
      revert: "Vrátit zpět",
      reverting: "Vracení…",
      revertedToast: "Změna vrácena.",
      revertFailed: "Změnu se nepodařilo vrátit.",
      empty: "Tento agent zatím nic nezměnil.",
    },
    verifications: {
      empty:
        "Zatím žádná ověření — předejte Prokopovi pracovní položku ve stavu interního testování.",
      when: "Kdy",
      workItem: "Pracovní položka",
      env: "Prostředí",
      mode: "Režim",
      verdict: "Verdikt",
      summary: "Shrnutí",
      tokens: "Tokeny vstup/výstup",
      cost: "Náklady",
      evidence: "Důkaz",
      screenshot: "snímek obrazovky",
      verdicts: {
        passed: "prošlo",
        failed: "neprošlo",
        not_testable: "nelze testovat",
        unclear: "nejasné",
      },
      stallsTitle: "Proč běhy skončily bez verdiktu (30 dní) — {{stalled}} z {{total}}",
      stallsEmpty: "Každý běh za posledních 30 dní skončil verdiktem.",
      latest: "poslední:",
      causes: {
        no_access: {
          label: "Potřeboval účet, který neměl",
          fix: "Sdílejte účet pro danou roli v kolekci trezoru projektu.",
        },
        model_error: {
          label: "Selhal model, ne aplikace",
          fix: "Zkontrolujte přístup agenta k modelu na AI Spend. Prokop to zkouší znovu sám a po dni dá vědět adminům.",
        },
        gate_locked: {
          label: "Za SSO bránou",
          fix: "Níže nastavte přihlášení Prokopa k bráně a dejte tomu účtu v Authentiku přístup do aplikace.",
        },
        locked_out: {
          label: "Přihlašovací zeď, žádný účet",
          fix: "Sdílejte testovací účet v kolekci trezoru projektu.",
        },
        missing_data: {
          label: "Žádná data k testování",
          fix: "Naplňte prostředí daty, nebo v tiketu napište, jak data získat.",
        },
        environment_broken: {
          label: "Prostředí je rozbité nebo změna není nasazená",
          fix: "Zkontrolujte nasazení prostředí.",
        },
        page_unreachable: { label: "Web se nenačetl", fix: "Zkontrolujte, že prostředí běží." },
        cannot_observe: {
          label: "Efekt není vidět z prohlížeče ani z testovací schránky",
          fix: "Otestujte ručně, nebo efekt zviditelněte.",
        },
        ticket_ambiguous: {
          label: "Tiket neříká, co má platit",
          fix: "Zpřesněte popis nebo doplňte kritéria přijetí.",
        },
        out_of_budget: {
          label: "Vyčerpán rozpočet",
          fix: "Zúžte tiket, nebo zvyšte TESTER_MAX_COST_USD_PER_WI.",
        },
        out_of_steps: {
          label: "Vyčerpány kroky",
          fix: "Zúžte tiket, nebo zvyšte TESTER_MAX_TURNS.",
        },
        inferred_only: {
          label: "Některá kritéria jdou ověřit jen z kódu",
          fix: "Uvedená kritéria ověřte ručně; běh je v aplikaci neviděl.",
        },
        unobserved: {
          label: "Úspěch nepodložený ničím viděným",
          fix: "Přečtěte si běh — usoudil z kódu nebo z kroku, který selhal.",
        },
        unfounded: {
          label: "Odškrtnutí nepodložené tím, co viděl",
          fix: "Přečtěte si běh: kritérium bylo odškrtnuto z kódu nebo po kroku, který selhal.",
        },
        smoke_unclear: {
          label: "Kontrola snímkem obrazovky nerozhodnutá",
          fix: "Obvykle jednorázové; spusťte znovu.",
        },
        not_in_browser: {
          label: "Mimo jeho dosah",
          fix: "Zkontrolujte ručně: logy serveru, monitoring, konfigurace nebo produkce.",
        },
        wrong_state: {
          label: "Tiket není v interním testování",
          fix: "Předejte ho ze správného stavu.",
        },
        no_environment: {
          label: "Prostředí nemá URL",
          fix: "Nastavte ji v nastavení projektu.",
        },
        no_browser: { label: "Chybí sidecar s prohlížečem", fix: "Zkontrolujte BROWSER_WS_URL." },
        advance_blocked: {
          label: "Prošlo, ale workflow odmítlo tiket posunout",
          fix: "Zkontrolujte přechodovou bránu tiketu (např. chybí manažer).",
        },
        production: {
          label: "Produkce — nikdy se netestuje",
          fix: "Zkontrolujte ručně, nebo tiket předejte na dev či test.",
        },
        production_tester: {
          label: "Před produkcí testuje člověk",
          fix: "Testuje ho produkční tester projektu; pro Prokopa není nic.",
        },
        other: { label: "Jiné", fix: "Přečtěte si shrnutí běhu." },
        unknown: { label: "Nezaznamenáno (starší běhy)", fix: "Přečtěte si shrnutí běhu." },
      },
    },
    access: {
      title: "Přístup k modelu",
      onFallback: "{{own}} dosáhlo limitu, proto běží na {{fallback}} do",
      itResets: "obnovení limitu",
      limited: "Dosažen limit předplatného — čeká do",
      gatewayKey: "Klíč brány",
      fromEnv: "— z prostředí nasazení —",
      none: "— žádný —",
      gatewayKeyHelp:
        "Platí to, co běží přes bránu, i vedle předplatného (embeddingy, modely, které předplatné neumí).",
      subscription: "Předplatné",
      noneGateway: "— žádné, běží na klíči brány —",
      runsOnNow: "Nyní běží na: {{engine}}.",
      fallbackSubscription: "Záložní předplatné",
      fallbackNone: "žádné, čeká na obnovení limitu",
      fallbackHelp:
        "Když předplatné vyčerpá 5hodinový nebo týdenní limit, agent běží na tomto a po obnovení limitu se vrátí.",
      model: "Model",
      modelDefault: "výchozí: {{model}}",
      modelHelp:
        "Model brány na API (např. gpt-5.5), model GPT na Codexu (prázdné = výchozí modely účtu). Předplatné Claude spouští jen modely Claude.",
      engine: {
        api: "API (klíč brány)",
        subscription: "Předplatné Claude",
        codex: "Předplatné ChatGPT (Codex)",
      },
      kind: { gateway_key: "klíč", claude_token: "Claude", codex_login: "ChatGPT" },
      saved: "Přístup k modelu uložen.",
      saveFailed: "Přístup k modelu se nepodařilo uložit.",
      testFailed: "Test se nepodařilo spustit.",
      works: "Funguje",
      failed: "Selhalo",
      testResult: "{{result}} na {{engine}}{{model}} za {{seconds}} s: {{detail}}",
      test: "Test",
      testing: "Testování…",
      saveFirst: "Nejdřív uložte",
      testHint: "Jedno malé skutečné volání na uloženém enginu",
      manage: "Spravovat klíče a předplatná",
      changed: "Změněno",
      by: "uživatelem {{name}}",
      limitsOwn: "Předplatné",
      limitsFallback: "Záložní",
      runsOnItNow: "(nyní na něm běží)",
      noLimits: "Limity zatím nenačteny.",
      sharedRead: "Sdílí každý agent na {{name}}, načteno",
      testReadsIt: "; Test ho načte hned.",
    },
    coder: {
      title: "Nastavení",
      rounds: "Pokusů o opravu při selhání kontrol",
      help: "Tiket je hotový, až když projde pipeline projektu, včetně lintu a dalších kontrol, které smí selhat. Po tolika červených pipeline po sobě tiket převezme člověk.",
      saved: "Nastavení uloženo.",
      saveFailed: "Nastavení se nepodařilo uložit.",
    },
    gate: {
      title: "SSO brána",
      description:
        "Weby za {{hosts}} se otevírají tímto servisním účtem (heslo aplikace v Authentiku, posílá se jen na weby za bránou). Jedno přihlášení pokryje všechny projekty za bránou. Zda se dostane dovnitř, je vidět u každého prostředí v kontrole přístupu testera v projektu.",
      usernameSet: "Uživatelské jméno (nastaveno)",
      usernameNotSet: "Uživatelské jméno (nenastaveno)",
      password: "Heslo aplikace",
      passwordStored: "uloženo, zadejte pro nahrazení",
      passwordNew: "uloží se šifrovaně",
      saved: "Přihlášení k bráně uloženo.",
      saveFailed: "Přihlášení k bráně se nepodařilo uložit.",
    },
    voice: {
      title: "Náklady na hlas",
      description:
        "Hovory jdou do hlavního workspace ElevenLabs, dokud má kredity, a do záložního, až mu dojdou; po obnovení kreditů se vrátí samy.",
      loadFailed: "Náklady na hlas se nepodařilo načíst.",
      primary: "Hlavní workspace",
      backup: "Záložní workspace",
      notSetUp: "{{workspace}}: není nastaven ({{key}}).",
      callsHere: " · hovory jdou nyní sem",
      noAgent: " · zatím bez agenta (spusťte provision:radim-elevenlabs)",
      plan: "plán",
      credits: "{{tier}}: využito {{used}} z {{limit}} kreditů, zbývá {{left}}{{renews}}.",
      renews: ", obnoví se {{date}}",
      creditsUnknown: "Kredity neznámé: klíč neumí přečíst plán (potřebuje oprávnění User read).",
      exhausted: "Došly kredity, přeskočeno do {{date}}.",
      calls:
        "Posledních {{days}} dní: {{count}} hovor(ů), {{minutes}} min, {{credits}} kreditů{{perMin}}{{cost}}.",
      perMin: " ({{n}} za min)",
      twilioError: "Twilio: {{error}}",
      twilioBalance: "Twilio: zůstatek {{balance}} {{currency}}{{month}}{{calls}}.",
      twilioMonth: ", tento měsíc ${{usd}}",
      twilioCalls: " (hovory: {{count}}, {{minutes}} min, ${{usd}})",
      twilioNotSetUp: "Twilio: není nastaveno (TWILIO_ACCOUNT_SID, TWILIO_AUTH_TOKEN).",
    },
    whatsapp: {
      title: "WhatsApp",
      description:
        "Lidé si propojí WhatsApp na svém profilu a pak s Radimem plánují projekty v chatu, psaním, hlasovými zprávami nebo hovorem (jeho agent v ElevenLabs hovory přijímá).",
      loadFailed: "WhatsApp Radima se nepodařilo načíst.",
      number: "Číslo",
      noNumber: "Meta číslo nevrátila: zkontrolujte WHATSAPP_PHONE_NUMBER_ID a token.",
      notSetUp: "Není nastaveno. Potřebuje WHATSAPP_CLOUD_TOKEN a WHATSAPP_PHONE_NUMBER_ID z Mety.",
      webhook:
        "Příchozí zprávy potřebují WHATSAPP_APP_SECRET a WHATSAPP_VERIFY_TOKEN a webhook /api/webhooks/whatsapp nastavený v Metě.",
    },
    queue: {
      title: "Fronta",
      loading: "Načítání…",
      empty: "Nic nečeká — předejte Prokopovi pracovní položku ve stavu interního testování.",
      held: "{{tickets}} drženo v {{projects}}.",
      projects_one: "{{count}} projektu",
      projects_few: "{{count}} projektech",
      projects_other: "{{count}} projektech",
      cost: "Jejich otestování nyní stojí nejvýše {{cost}} — jsou to sečtené limity na tiket a většina tiketů vyjde výrazně levněji.",
      pass: {
        nightly: "Průchod předanými tikety",
        asap: "Požadavek asap",
        manual: "Ruční průchod",
      },
      running: "{{pass}} právě běží — vždy jen jeden průchod.",
      noBrowser: "Na serveru není nastaven testovací prohlížeč, takže nic nemůže běžet.",
      prokopPaused: "Prokop je pozastaven.",
      start: "Otestovat celou frontu hned",
      started_one: "Testuji {{count}} tiket.",
      started_few: "Testuji {{count}} tikety.",
      started_other: "Testuji {{count}} tiketů.",
      startedDesc: "Dokončují se po jednom — každý hlásí do svého tiketu.",
      startFailed: "Průchod se nepodařilo spustit.",
    },
    guide: {
      heading: "Co tento agent umí",
      configure: "Nastavit",
      useIt: "Použít",
      suggestions: "Návrhy",
      fullManual: "Úplná příručka:",
      inWiki: "ve wiki.",
      analyst: {
        intro:
          "Pošlete mu kanál a on navrhne akce — {{proposes}}. Sám nikdy nic neprovede: každý návrh čeká v sekci",
        intro2:
          "na vaše schválení či zamítnutí a každý ukazuje své zdůvodnění, citaci ze zdroje a odkaz zpět na něj.",
        proposes:
          "nové pracovní položky / úkoly / chyby / nápady, komentáře ke stávajícím položkám, změny priority, doplnění specifikace, pevné ceny, odhady a slučování duplicit",
        footer:
          "Aktivita níže ukazuje každý běh se skutečnou spotřebou tokenů a odhadovanými náklady; Pozastavit zastaví vše okamžitě.",
        wikiAnalysis: "AI Analýza",
        wikiAgents: "Agenti",
        email: {
          title: "Přeposlaný e-mail",
          what: "Čte e-maily klientů přeposlané do sledované schránky (zhruba každých 15 min) a navrhuje navazující akce s projektem odesílatele jako kontextem.",
          how1: "Přepošlete (nebo nechte klienta napsat) do sledované schránky — adresu najdete na stránce E-mail.",
          how2: "Přiřaďte adresu nebo doménu odesílatele k projektu v E-mail → Směrování.",
          how3: "Návrhy se objeví v Návrzích; čtou se i přílohy (obrázky, PDF).",
          link: "Zdroje e-mailů",
        },
        whatsapp: {
          title: "Chaty WhatsApp",
          what: "Průběžně čte skupinové chaty, které spárujete, a z nových zpráv dělá návrhy.",
          how1: "Jednou propojte účet WhatsApp (Účet → QR kód).",
          how2: "Spárujte skupinu pomocí „Spárovat nový chat“ a přiřaďte ji k projektu.",
          how3: "Spárovaný chat kdykoli otevřete a uvidíte přepis i to, k čemu která zpráva vedla.",
          link: "Zdroje WhatsApp",
        },
        discord: {
          title: "Textové kanály Discordu",
          what: "Bot pasivně čte textové kanály, které dáte na jeho seznam sledovaných — pracovní diskuse týmu se mění v návrhy.",
          how1: "Pozvěte bota na server (nastavení viz okno Bot) a kanál „Sledujte“.",
          how2: "Přiřaďte kanál k projektu pro přesnější návrhy znalé položek.",
          link: "Zdroje Discord",
        },
        meetings: {
          title: "Hlasové schůzky",
          what: "Pozvěte agenta do hlasového kanálu Discordu — zaznamená, kdo co řekl (zvuk po mluvčích), schůzku přepíše a navrhne navazující kroky.",
          how1: "Na Schůzkách klikněte na „Nahrát schůzku“, vyberte hlasový kanál a projekt a pak „Připojit a nahrávat“.",
          how2: "Po schůzce „Zastavit a analyzovat“ — přepis a návrhy dorazí během pár minut.",
          how3: "Zvuk se po úspěšné analýze smaže; uchová se jen přepis.",
          link: "Schůzky",
        },
        transcripts: {
          title: "Přepisy schůzek",
          what: "Vložte libovolný přepis (hovor, poznámky z osobní schůzky) a získáte stejnou analýzu ručně.",
          how1: "Na Schůzkách „Přidat schůzku“ → vyberte projekty → vložte text → „Analyzovat přepis“.",
          link: "Schůzky",
        },
        duplicates: {
          title: "Hledání duplicit",
          what: "Projde otevřené pracovní položky a hledá tikety, které sledují stejnou práci (text + význam), a navrhne sloučení.",
          how1: "V Návrzích klikněte na „Hledat duplicity“; každou navrženou skupinu zkontrolujte a Sloučte nebo Zamítněte.",
        },
      },
      tester: {
        intro:
          "Prokop je tester týmu: předejte mu tiket připravený k internímu testování a on ověří funkci ve skutečném prohlížeči — nejdřív si přečte wiki projektu pro kontext — pak okomentuje výsledek a posune tiket dál: při úspěchu ho posune, při selhání vrátí vývojáři, a když testovat nemůže, vrátí ho zpět. Pracuje v noci; když věc nepočká, napište do komentáře „asap“.",
        footer:
          "Aktivita níže ukazuje každý běh se skutečnou spotřebou tokenů a odhadovanými náklady; Pozastavit zastaví vše okamžitě.",
        wikiName: "Agent Tester",
        hand: {
          title: "Předejte mu tiket",
          what: "Přiřaďte Prokopovi pracovní položku, která je ve stavu interního testování na dev nebo test. Převezme ji do minuty, stejně jako Metoděj a Vratislav své. Produkci netestuje nikdy: ověřuje používáním aplikace a na main by to znamenalo skutečné objednávky a skutečná data.",
          how1: "Je členem každého projektu — před předáním tiketu není co nastavovat.",
          how2: "U pracovní položky v interním testování použijte „Předat Prokopovi“ (nebo nastavte řešitele na Prokopa). Kde projekt chce test člověkem před produkcí, tlačítko chybí a Hub Prokopa jako řešitele odmítne: test dělá produkční tester.",
          how3: "Ve skutečném prohlížeči otevře nasazený web projektu pro dané prostředí.",
          how4: "Ověřuje jen to, co tiket popisuje.",
          how5: "Tiket v interním testování na main se hned vrací — ten zkontrolujte ručně.",
        },
        asap: {
          title: "Jakmile je jeho",
          what: "Každou minutu testuje, co drží a od předání, přesunu nebo komentáře nezkoušel. Tiket, který si nechal bez verdiktu, zkusí znovu za den, ne každou minutu.",
          how1: "Chcete, aby se podíval na něco konkrétního? Napište k tiketu komentář „@Prokop … asap“ a řekněte co.",
          how2: "Komentář slouží zároveň jako zadání: napište, na co se podívat, a on se tam zaměří.",
          how3: "„Otestovat celou frontu hned“ na této stránce otestuje znovu vše, co drží, zkoušené i nezkoušené.",
          how4: "Vždy jen jeden průchod: když běží dávka, tlačítko to řekne místo spuštění druhé.",
          how5: "Bere jen tikety, které drží; když ho požádáte o cizí, řekne to.",
        },
        result: {
          title: "Co s výsledkem udělá",
          what: "Výsledek okomentuje v tiketu a provede odpovídající akci workflow, takže se věc posouvá sama.",
          how1: "Prošlo → komentuje ✅ a posune tiket do dalšího kroku (míč jde dalšímu vlastníkovi).",
          how2: "Neprošlo → komentuje ❌ s postupem reprodukce a snímkem obrazovky a vrátí tiket vývojáři.",
          how3: "Nelze testovat / nejasné → komentuje proč a vrátí tiket tomu, kdo ho předal.",
        },
        login: {
          title: "Stránky za přihlášením",
          what: "Účet k webu najde v Trezoru podle jeho URL a přihlásí se sám — není co nastavovat. Administrační obrazovky už nekončí jako „nelze testovat“.",
          how1: "Testovací účty držte v kolekci Trezoru projektu; testovací pojmenujte „test…“.",
          how2: "Více odpovídajících účtů a žádný neoznačený jako testovací → nepřihlásí se žádným a řekne to.",
          how3: "Nikdy na produkci: na main vždy testuje odhlášený.",
          how4: "Na každém webu se přihlásí jednou a session použije pro celou dávku.",
        },
        external: {
          title: "Kontrola jiných systémů",
          what: "Když se efekt tiketu projeví mimo testovaný web — objednávka v ERP zákazníka, vystavená faktura — otevře ten systém v prohlížeči a podívá se. Mnohé nemají použitelné API; takhle by to kontroloval i člověk.",
          how1: "Nastavení projektu → „Externí služby (Prokop)“: název, URL, k čemu slouží.",
          how2: "Co tam není uvedeno, je pro něj nedostupné, včetně odkazů na stránce.",
          how3: "Přihlásí se tím, co Trezor pro danou URL drží — proto tam držte jen testovací účty.",
        },
        smoke: {
          title: "Smoke vs. agentní — a cena",
          what: "Začne levnou smoke kontrolou (jeden snímek obrazovky + signály načtení). Jen když z ní tiket nepoznáte, přejde na plné agentní procházení (klikání, psaní).",
          how1: "Většina tiketů se vyřeší smoke kontrolou za zlomek centu.",
          how2: "Agentní běhy omezuje strop nákladů na tiket a limit kroků.",
          how3: "Skutečná spotřeba tokenů a náklady každého běhu jsou v Aktivitě níže; Pozastavit zastaví vše.",
        },
      },
      maintainer: {
        intro:
          "Vratislav je správce týmu: prochází merge request každého tiketu zaparkovaného u dev merge brány, který drží — proti tiketu i proti okolnímu kódu — a pak ho sloučí, nebo vrátí vývojáři s nálezy. Slučuje do dev a nikam jinam; test a produkce zůstávají na rozhodnutí člověka.",
        footer: "Aktivita níže ukazuje každý běh; Pozastavit zastaví vše okamžitě.",
        wikiName: "Agent Vratislav",
        project: {
          title: "Dejte mu projekt",
          what: "V projektu, jehož není členem, nesloučí nic. Přidat ho v GitLabu jako Maintainera je celé přihlášení — synchronizace členů to zrcadlí do Hubu během pár minut.",
          how1: "Přidejte „Vratislava Síťoleva“ do projektu v GitLabu s rolí Maintainer.",
          how2: "Od té chvíle si sám bere prázdný slot Maintainera na tiketu — člověk, který už ve slotu je, není nikdy vytlačen.",
          how3: "Když ho vynecháte, každá merge brána zůstane stejně ruční jako dřív.",
        },
        gate: {
          title: "Dev merge brána",
          what: "Každých pár minut se podívá na tikety zaparkované u „merge do dev“, které drží, a vezme ty, jejichž merge request je připraven ke čtení.",
          how1: "Slučuje jen do dev: MR mířící na main nebo test nechá být a řekne to.",
          how2: "Připravený znamená: není draft, bez konfliktů, zelená pipeline, schválení udělena, diskuse vyřešeny.",
          how3: "Cokoli jiného ho zastaví před review: jednou okomentuje proč a mlčí, dokud se to nezmění.",
          how4: "Po sloučení posune tiket do interního testování, kde ho převezme Prokop.",
        },
        review: {
          title: "Nejdřív čte kód",
          what: "Před sloučením projde merge request jako zkušený správce: dělá, co tiket chtěl, nerozbíjí něco jiného, je správný, je napsaný tak, jak se v tomto repozitáři píše. Přečte diff a pak otevře okolní soubory — volající, testy, sousední soubor kvůli konvencím.",
          how1: "Schválí → sloučí a review (i s drobnými poznámkami) skončí na MR i na tiketu.",
          how2: "Požádá o změny → nesloučí: nálezy jdou na obojí a tiket se vrací vývojáři — je-li to Metoděj, opraví je a vrátí se to znovu.",
          how3: "Stejný commit bez změny → řekne to místo placení stejného review dvakrát.",
          how4: "Po 3 kolech přestane tiket posílat zpět a požádá člověka, ať se podívá.",
          how5: "Příliš velký diff na poctivé přečtení nebo nenastavená AI brána znamená žádné sloučení — nikdy sloučení bez review.",
        },
        never: {
          title: "Co nedělá nikdy",
          what: "Produkce je vaše. Nikdy neslučuje do main, nepovyšuje dev→test, neslučuje kód, který nečetl, a nikdy za nikoho neřeší konflikt ani nic neschvaluje.",
          how1: "Brány test a main zůstávají ruční — tlačítko „Sloučeno do …“, jako dřív.",
          how2: "Nic nespouští — žádné testy, build ani prohlížeč; to je Prokopova polovina.",
          how3: "Pozastavit na této stránce ho okamžitě zastaví; každé jeho sloučení je běžné sloučení v GitLabu, které můžete vrátit.",
        },
      },
    },
  },
};
